module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/line-gray-05de2b43cc4d5ffe41fa17a42294fadd.svg";